import { useAuthBootstrap } from '@/hooks/useAuth';
import { AppRouter } from './router';

export function App() {
  useAuthBootstrap();

  return <AppRouter />;
}
